<template>
   <div class="videoH5">
      <TopTabs :list="this.$nav20"/>
       <div class="tsnn_top">
                <div class="tsnn_title"
                  v-for="(item, index) in list" :key="index"
                  @click="toPage(index)">
                <div :class="index === id ? 'tsnn_active': ''">{{item}}</div>
                <div v-if="index == id"
                     :class="index === id ? 'tsnn_border': ''">
                </div>
             </div>
            </div>
      <div class="tsnn_bottom">
      <div class="spnn_box" :class="(index + 1) % 3 === 0 ? 'no_margin':''"
          v-for="(item, index) in videoList" :key="index" @click="isPush(item)">
        <img class="spnn_box_bgimg" :src="item.cover_url" alt="">
        <img class="spnn_box_onplay" src="@/assets/img_app/play.png" alt="">
        <!-- <div class="spnn_box_text">{{item.title}}</div>  -->
      </div>
  </div>
   </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'Spnn',
  components: { TopTabs },
  props: {},
  data () {
    return {
      id: 0,
      list: ['视频集锦', '魅力校园'],
      videoList: [],
      total: 0,
      type: 1
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {},
  methods: {
    async getList () {
      const { data, total } = await this.$get('/ow/video', { type: this.type })
      this.videoList = data
      this.total = total
    },
    isPush (item) {
      this.$router.push({ path: '/campus/details?ids=0', query: { url: item.video_url } })
    },
    toPage (index) {
      this.id = index
      if (index === 0) {
        this.type = 1
      } else {
        this.type = 2
      }
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.videoH5 {
  min-height: 86.5vh;
}
    .tsnn_top {
        display: flex;
        justify-content: flex-start;
        padding: 3.7333vw 4.2667vw;
        border-bottom: 1px solid #B3B3B3;
        margin-bottom: 2.1333vw;
        .tsnn_title {
          position: relative;
          margin-right: 4.2667vw;
          cursor: pointer;
          font-size: 3.2vw;
        }
        .tsnn_border {
          position: absolute;
          left: 1.9vw;
          bottom: -3.7333vw;
          width: 8.5333vw;
          height: 0.4vw;
          background: #02349C;
        }
        .tsnn_active {
          color: #02349C;
        }
     }
  .tsnn_bottom {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 4.2667vw;

    .spnn_box {
      width: 43.6vw;
      height: 28vw;
      margin-bottom: 9.3333vw;

      position: relative;
      cursor: pointer;
      .spnn_box_bgimg {
        width: 100%;
        height: 100%;
      }
      .spnn_box_onplay {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 6.4vw;
        height: 6.4vw;
        transform: translate(-50%, -50%);
      }
      // .spnn_box_text {
      //   position: absolute;
      //   bottom: 0;
      //   width: 100%;
      //   height: 34px;
      //   color: #fff;
      //   line-height: 34px;
      //   text-align: center;
      //   background: #000000;
      //   opacity: .5;
      //   overflow: hidden;
      //   white-space: nowrap;
      //   text-overflow: ellipsis;
      //   padding: 0 12px;

      // }
    }
    .no_margin {
      margin-right: 0;
    }
  }
</style>
